import type { FaireThemeEntity } from "../../entity_types/theme";

export const holistic_family_wellness: FaireThemeEntity = {
  token: "holistic-family-wellness",
  type: "theme",
  name: "Holistic Family Wellness",
  description: "All-natural remedies for every age, featuring therapeutic supplements and soothing bath rituals.",
  teaser: "Remedies for the whole family -- from the brands you already reorder.",
  detail: "You frequently stock essential oils, healing salves, and oral supplements. This theme rounds out your wellness offering with RELIEF supplements for both children and adults from Rowe Casa Organics.",
  bgColor: "#F5F0D4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_6h33ns0q1u",
    "p_2qcw8mc5sn",
    "p_e39g47q543",
    "p_avrciqh5ce",
    "p_bc586tp19t",
    "p_ao6y1u2z37",
    "p_mb7pz63w34",
    "p_ca8vg3knqx",
    "p_df9jt0hwsn",
    "p_89hzri8q58",
    "p_6bqyrkmnpc",
    "p_q9e66qz8ud",
    "p_1386xqnw1j",
    "p_ksnfarka6p",
    "p_bvyqe5kjz5",
    "p_ad2fhakhhp",
    "p_u24uamt3xs",
    "p_79eudmu4xs",
    "p_ev7jgmu4dg",
    "p_j9x8z54bgt",
    "p_1m5dcxhge7",
    "p_6lbg51g67p",
    "p_v9vh5q5drf",
    "p_k3a3nd2u3s",
    "p_xvfa5hz8qr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
